import { CoreButton, CoreModal } from '@komodo-design-system/komodo-components-react';
// Try using the index import instead
import './AssetAudit.scss';
import AuditComparisonTable from './AuditComparisonTable';

export default function AssetAuditModal({
  isOpen,
  onClose,
  currentAsset,
  previousAsset
}: {
  isOpen: boolean;
  onClose: () => void;
  currentAsset: any;
  previousAsset: any;
}) {
  return (
    <div className="audit-compare-container">
      <CoreModal
        isopen={isOpen}
        closeicon
        onModalClosed={onClose}
        header='Asset Change Comparison'
      >
        <AuditComparisonTable
          obj1={previousAsset}
          obj2={currentAsset}
          title="Asset Change Comparison"
        />
        <div className='audit-modal-actions'>
          <CoreButton size='small' className='audit-modal-close-btn' label='Close' onClick={onClose}></CoreButton>
        </div>
      </CoreModal>
    </div>
  );
}
